export const InformationIcon = ({
  fill = "#1453F5",
  characterFill = "#1453F5",
  opacity = 0.4,
}: {
  fill?: string;
  characterFill?: string;
  opacity?: number;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      opacity={opacity}
      d="M0.709229 7.0352C0.709229 10.4985 3.51678 13.306 6.98006 13.306C10.4433 13.306 13.2509 10.4985 13.2509 7.0352C13.2509 3.57191 10.4433 0.764362 6.98006 0.764362C3.51678 0.764362 0.709229 3.57191 0.709229 7.0352Z"
      fill={fill}
    />
    <path
      d="M6.43982 6.41626C6.55638 6.41619 6.6955 6.41682 6.81482 6.43286C6.9589 6.45228 7.15852 6.5041 7.32751 6.6731C7.49641 6.84219 7.54839 7.04177 7.56775 7.18579C7.58376 7.3051 7.58345 7.4443 7.58337 7.56079V9.91626C7.58337 10.2383 7.32236 10.5 7.00037 10.5002C6.6782 10.5002 6.41638 10.2384 6.41638 9.91626V7.58325C6.09445 7.5831 5.83353 7.32218 5.83337 7.00024C5.83337 6.67817 6.09435 6.41641 6.41638 6.41626C6.42393 6.41626 6.43206 6.41626 6.43982 6.41626ZM7.00232 4.08325C7.32293 4.08325 7.58319 4.34425 7.58337 4.66626C7.58337 4.98843 7.32305 5.25024 7.00232 5.25024H6.99744C6.67671 5.25024 6.41638 4.98843 6.41638 4.66626C6.41656 4.34425 6.67682 4.08325 6.99744 4.08325H7.00232Z"
      fill={characterFill}
    />
  </svg>
);
